import React from "react"
import { Plural, Trans } from "@lingui/macro"
import SidebarBoxContent from "../SidebarBoxContent/SidebarBoxContent"
import { useCourtesyHold } from "../../app-core/features/courtesy-hold/use-courtesy-hold"
import Tag from "../Tag/Tag"
import styles from "./CourtesyHoldAvailableBox.module.scss"

type Props = {
    // keep-line
}

const CourtesyHoldAvailableBox: React.FC<React.PropsWithChildren<Props>> = () => {
    const courtesyHold = useCourtesyHold()
    if (courtesyHold.type === "expired") return null

    const days = <Plural value={courtesyHold.days} one="# day" other="# days" />

    return (
        <SidebarBoxContent
            dataContentName="courtesy_hold_banner"
            iconName="suites"
            tag={
                <Tag className={styles.tagBorder}>
                    <Trans>Free of charge - price blocked</Trans>
                </Tag>
            }
        >
            <Trans>Take advantage of our courtesy hold and enjoy a {days} price lock - obligation-free.</Trans>
        </SidebarBoxContent>
    )
}

export default CourtesyHoldAvailableBox
